
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class EmployeeSummaryActive extends Vue {
  @Prop({ type: Boolean, required: true }) readonly isActive!: boolean;

  get label() {
    return this.isActive ? "Active" : "Leaver";
  }
}
